import type { CoprincipalAccountSource } from '../store/schema/AccountSourceList';
import getCoprincipalAccounts, {
    ContractsSupportedFilter,
    StartupFilter,
} from './getCoprincipalAccounts';

/**
 * Finds coprincipal accounts whose authenticating user has the specified PUID and tenant ID.
 * @param puid The Passport Unique ID (PUID) of the authenticating user
 * @param tenantId The AAD Tenant ID of the authenticating user
 * @returns Matching CoprincipalAccountSource items, or an empty array if not found
 */
export default function getCoprincipalAccountsByPuidAndTid(
    puid: string,
    tenantId: string
): CoprincipalAccountSource[] {
    if (!puid || !tenantId) {
        return [];
    }

    const lowerPuid = puid.toLowerCase();
    const lowerTid = tenantId.toLowerCase();
    return getCoprincipalAccounts(
        StartupFilter.StartingOrCompleteOrError,
        ContractsSupportedFilter.Any
    ).filter(
        account =>
            account.authenticatingUserIdentifiers?.puid?.toLowerCase() === lowerPuid &&
            account.authenticatingUserIdentifiers?.tenantId?.toLowerCase() === lowerTid
    );
}
